import GameLayout from '~/pages/authentified/GameLayout';
import bg from '@assets/images/background/mode-solo-bg.png';
import { styled } from 'styled-components';
import BattleRequest from '~/components/game/battle-request';

function BattleRequestPage() {
  return (
    <GameLayout withoutHeader withoutFooter background={bg}>
      <SDivBlur $background />
      <BattleRequest />
    </GameLayout>
  );
}

export default BattleRequestPage;

const SDivBlur = styled.div<{ $background?: boolean }>`
  background: ${({ $background }) =>
    $background
      ? `linear-gradient(180deg, rgba(0, 202, 191, 0.60) 0%, rgba(0, 173, 212, 0.60) 100%)`
      : 'none'};
  backdrop-filter: ${({ $background }) =>
    $background ? `blur(18px)` : 'none'};
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;
